import { render, staticRenderFns } from "./IntegratorFeatureFlagConfigTab.vue?vue&type=template&id=62d1363a"
import script from "./IntegratorFeatureFlagConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorFeatureFlagConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports